export default __webpack_public_path__ + "static/media/slider3.5b0810a4.jpg";